"use client";
import { FunctionComponent, useEffect, useRef } from "react";

const YotpoQuestion: FunctionComponent<YotpoQuestionProps> = ({ mpId, className }) => {
  // Note that the scripts used to create the element below are handled in questionsAndAnswers.tsx
  const containerRef = useRef<HTMLDivElement>(null);

  // "N Questions \ N Answers" -> "N Questions and N Answers", re-applied on Yotpo re-render.
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const rewrite = () => {
      const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT);
      const textNodes: Text[] = [];
      while (walker.nextNode()) textNodes.push(walker.currentNode as Text);

      textNodes.forEach((node) => {
        const value = node.nodeValue ?? "";
        if (!value.includes("\\")) return;
        const parentText = node.parentElement?.textContent ?? "";
        const inCount =
          (/Questions/i.test(value) && /Answers/i.test(value)) ||
          (value.trim() === "\\" && /Questions/i.test(parentText) && /Answers/i.test(parentText));
        if (inCount) {
          node.nodeValue = value.replace(/\s*\\\s*/g, " and ");
        }
      });
    };

    let scheduled = false;
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        rewrite();
      });
    };

    rewrite();
    const observer = new MutationObserver(schedule);
    observer.observe(container, { childList: true, subtree: true, characterData: true });
    return () => observer.disconnect();
  }, [mpId]);

  return (
    <div
      ref={containerRef}
      className={`${className} yotpo QABottomLine`}
      data-appkey={YOTPO_KEY}
      data-product-id={mpId}
    />
  );
};

type YotpoQuestionProps = {
  mpId: number;
  className: string;
};

export const YOTPO_KEY = "k0ISk4VuVmhyvM3k5lrJdmv4nfZwZ4QfG4gpdvqH";

export default YotpoQuestion;
